var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnionRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 12,
    viewBox: "0 0 41 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4797 5.18003L37.4194 7.0708L39.1342 1.53823",
    stroke: "#FB6E4B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.269 6.18104C36.6459 6.58475 37.2787 6.60652 37.6824 6.22964C38.0861 5.85277 38.1079 5.21998 37.731 4.81627C35.8678 2.82039 33.9285 1.74193 32.0202 1.43106C30.1077 1.11952 28.3354 1.59705 26.8493 2.5154C25.1016 3.59545 23.7062 5.31109 22.8691 7.18314C21.6203 5.26657 19.4581 3.99957 17 3.99957C14.3075 3.99957 11.97 5.51978 10.799 7.74871C9.88202 6.67805 8.52024 5.99957 7 5.99957C4.23858 5.99957 2 8.23815 2 10.9996H4C4 9.34272 5.34315 7.99957 7 7.99957C8.65685 7.99957 10 9.34272 10 10.9996H12C12 8.23815 14.2386 5.99957 17 5.99957C19.7614 5.99957 22 8.23815 22 10.9996H24C24 8.59079 25.5654 5.65994 27.9007 4.21674C29.0396 3.5129 30.3298 3.18206 31.6986 3.40504C33.0715 3.62868 34.6322 4.42761 36.269 6.18104Z",
    fill: "url(#paint0_linear_1_11)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 11.4996C0.5 11.2235 0.723858 10.9996 1 10.9996H5C5.27614 10.9996 5.5 11.2235 5.5 11.4996C5.5 11.7758 5.27614 11.9996 5 11.9996H1C0.723858 11.9996 0.5 11.7758 0.5 11.4996Z",
    fill: "url(#paint1_linear_1_11)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 11.4996C7.5 11.2235 7.72386 10.9996 8 10.9996H14C14.2761 10.9996 14.5 11.2235 14.5 11.4996C14.5 11.7758 14.2761 11.9996 14 11.9996H8C7.72386 11.9996 7.5 11.7758 7.5 11.4996Z",
    fill: "url(#paint2_linear_1_11)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 11.4996C19.5 11.2235 19.7239 10.9996 20 10.9996H26C26.2761 10.9996 26.5 11.2235 26.5 11.4996C26.5 11.7758 26.2761 11.9996 26 11.9996H20C19.7239 11.9996 19.5 11.7758 19.5 11.4996Z",
    fill: "url(#paint3_linear_1_11)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_11",
    x1: 37.4194,
    y1: 1.33594,
    x2: -5.52977,
    y2: 19.3022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F27A60",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_11",
    x1: 0.777778,
    y1: 11.4996,
    x2: 3.81499,
    y2: 9.43225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC8368",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#FCD7BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E27335",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_11",
    x1: 7.88889,
    y1: 11.4996,
    x2: 11.1498,
    y2: 8.39213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC8368",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#FCD7BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E27335",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_11",
    x1: 19.8889,
    y1: 11.4996,
    x2: 23.1498,
    y2: 8.39213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC8368",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#FCD7BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E27335",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionRed);
export default __webpack_public_path__ + "static/media/union-red.706855f44c8467a0f24f79a478eec3ec.svg";
export { ForwardRef as ReactComponent };